import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, n = /* @__PURE__ */ o("path", { d: "M41.228 22.08H6.77a.96.96 0 0 0-.96.96v1.92c0 .53.43.96.96.96h34.458c.53 0 .96-.43.96-.96v-1.92a.96.96 0 0 0-.96-.96Z" }, null, -1), r = [
  n
];
function s(a, d) {
  return e(), t("svg", c, r);
}
const _ = { render: s };
export {
  _ as default,
  s as render
};
//# sourceMappingURL=less.svg.mjs.map
